import ThankYouComponent from './ThankYouComponent';
import { TEXT } from 'locales/translations';
import { Button } from 'Common';
import { linkHandler } from 'utils/linkHandler';

export const ThankYouUpgrade = () => {
  return (
    <ThankYouComponent title={TEXT.thankYouUpgrade.title} showFooter>
      <Button variant="inverted" to={linkHandler.get('library')}>
        {TEXT.thankYou.btnLibrary}
      </Button>
    </ThankYouComponent>
  );
};

export default ThankYouUpgrade;
